import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { AccelerationTasks } from '~src/dataAcceleration/resources/AccelerationTasks';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { AccelerationTaskContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const AccelerationTaskDefinition: ExplorableItemDefinition = {
  itemType: 'accelerationTask',
  pluralName: Messages.accelerationTasks,
  singularName: Messages.accelerationTask,
  emptyStateMessage: Messages.accelerationTasksEmptyMessage,
  contentFilterKeys: AccelerationTaskContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['accelerationTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return AccelerationTasks.all().withExtraParams(AccelerationTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
